import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'services',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: 'quote',
    labelKey: 'chatbot.suggestions.quote',
    messageKey: 'chatbot.suggestions.quoteMessage',
  },
  {
    id: 'certifications',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 0434 645075',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@fgautomazioni.it',
  },
]
